<div class="settings-content">
  <!-- Header -->
  <div class="header">
    <div class="title">Settings</div>
    <div class="description">Manage API keys and other workspace settings here</div>
  </div>

  <!-- API Keys -->
  <div class="api-keys-content">
    <div class="section-title">API Keys</div>

    <!-- Create -->
    <div class="create-key">
      <div class="row name-row">
        <input class="input" placeholder="Key name (e.g. Iris ingest)" [(ngModel)]="form.name">
        <input class="input" type="date" [(ngModel)]="form.expiresAt">
        <button class="button" [class.disabled]="!canCreate()" (click)="create()">Create</button>
      </div>
      <div class="row scopes-row">
        @for (scope of scopeOptions; track scope.key) {
          <label class="scope">
            <input
              type="checkbox"
              [checked]="isScopeSelected(scope.key)"
              (change)="toggleScope(scope.key)">
            <span>{{ scope.label }}</span>
          </label>
        }
      </div>
    </div>

    <!-- Revealed secret (shown once after create or rotate) -->
    @if (revealedSecret) {
      <div class="reveal">
        <div class="reveal-header">
          <div class="reveal-title">Copy this key now — it will not be shown again</div>
          <mat-icon svgIcon="close" class="reveal-close" (click)="dismissSecret()"></mat-icon>
        </div>
        @if (revealedSecret.name) {
          <div class="reveal-name">{{ revealedSecret.name }}</div>
        }
        <div class="reveal-body">
          <code class="reveal-value">{{ revealedSecret.apiKey }}</code>
          <button class="button" (click)="copy(revealedSecret.apiKey)">Copy</button>
        </div>
      </div>
    }

    <!-- List -->
    <div class="keys">
      @for (key of keys; track key.id) {
        <div class="key" [class.revoked]="key.status === 'revoked'">
          <div class="info">
            <div class="key-name">{{ key.name }}</div>
            <div class="key-meta">
              @if (key.keyPrefix) {
                <span class="prefix">{{ key.keyPrefix }}…</span>
              }
              <span class="status" [ngClass]="key.status">{{ key.status }}</span>
              @if (key.scopes?.length) {
                <span class="scopes">
                  @for (scope of key.scopes; track scope) {
                    <span class="scope-tag">{{ scopeLabel(scope) }}</span>
                  }
                </span>
              }
            </div>
            <div class="key-dates">
              @if (key.lastUsedAt) {
                <span>Last used: {{ key.lastUsedAt | date:'medium' }}</span>
              } @else {
                <span>Never used</span>
              }
              @if (key.expiresAt) {
                <span>Expires: {{ key.expiresAt | date:'mediumDate' }}</span>
              }
            </div>
          </div>
          <div class="actions">
            <button
              class="button secondary"
              [class.disabled]="key.status === 'revoked'"
              (click)="rotate(key)">
              Rotate
            </button>
            <button
              class="button secondary"
              [class.disabled]="key.status === 'revoked'"
              (click)="revoke(key)">
              Revoke
            </button>
            <div class="action-icon" (click)="delete(key)" matTooltip="Delete" [matTooltipShowDelay]="1000">
              <mat-icon svgIcon="trash" class="icon"></mat-icon>
            </div>
          </div>
        </div>
      } @empty {
        <div class="empty">No API keys yet. Create one above.</div>
      }
    </div>
  </div>
</div>
